<script>
import AdaptsRelateFieldtype from './AdaptsRelateFieldtype.vue';

export default {

    mixins: [AdaptsRelateFieldtype]

};
</script>



// WEBPACK FOOTER //
// PagesFieldtype.vue?7b35ed10